import React from 'react'

const CouponVector = () => {
    return (
        <svg
            width="3"
            height="81"
            viewBox="0 0 2 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 0.100586V80.6269"
                stroke="#9B9B9B"
                strokeWidth="1.89474"
                strokeLinejoin="round"
                strokeDasharray="6.63 6.63"
            />
        </svg>
    )
}

export default CouponVector
